import './style.css'
import CodeDisplay from '../../components/CodeDisplay';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useScrollHandler } from './DocsUtils';

const StorageAPI = () => {

  const { t } = useTranslation();
  const [language, setLanguage] = useState('javascript');
  const codeExamples = {
    uploadFile: `const url = await manager.storage.getUploadUrl({\n\tstorageName: 'YOUR_STORAGE_NAME',\n\tfileName: 'YOUR_FILE_NAME',\n\tcontentType: 'YOUR_FILE_TYPE'\n});\n\nawait fetch(url, {\n\tmethod: 'PUT',\n\tbody: file,\n\theaders: { 'Content-Type': 'YOUR_FILE_TYPE' }\n});`,
    getFileContent: `const url = await manager.storage.getFileContentUrl({\n\tstorageName: 'YOUR_STORAGE_NAME',\n\tfileName: 'YOUR_FILE_NAME'\n});\n\nconst blob = await fetch(url).then(res => res.blob());\nconsole.log(blob); // ${t('docs.storage.code-example.blob-object')}`,
    deleteFile: `await manager.storage.deleteFile({\n\tstorageName: 'YOUR_STORAGE_NAME',\n\tfileName: 'YOUR_FILE_NAME'\n});`,
  };

  const [closest, setClosest] = useState('');

  useScrollHandler(closest, setClosest);

  return (
    <div className='w-full flex flex-col md:flex-row-reverse p-4'>
      <div className='w-full md:w-64 pl-4 md:pl-8 md:sticky top-4 text-xs md:text-sm self-start md:border-l'>
        <div className='my-4 mt-2'>{t('docs.menu')}</div>
        <div className={`my-4 cursor-pointer ${closest === 'title' ? 'font-bold text-primary' : 'font-light'}`} onClick={() => document.getElementsByTagName('main')?.[0].scrollTo({ top: document.getElementById(`title`)?.offsetTop! - 32, behavior: 'smooth' })}>{t('docs.storage.menu.title')}</div>
        <div className={`my-4 ml-2 cursor-pointer ${closest === 'title-upload-file' ? 'font-bold text-primary' : 'font-light'}`} onClick={() => document.getElementsByTagName('main')?.[0].scrollTo({ top: document.getElementById(`title-upload-file`)?.offsetTop! - 32, behavior: 'smooth' })}>{t('docs.storage.menu.upload-file')}</div>
        <div className={`my-4 ml-2 cursor-pointer ${closest === 'title-download-file' ? 'font-bold text-primary' : 'font-light'}`} onClick={() => document.getElementsByTagName('main')?.[0].scrollTo({ top: document.getElementById(`title-download-file`)?.offsetTop! - 32, behavior: 'smooth' })}>{t('docs.storage.menu.download-file')}</div>
        <div className={`my-4 ml-2 cursor-pointer ${closest === 'title-delete-file' ? 'font-bold text-primary' : 'font-light'}`} onClick={() => document.getElementsByTagName('main')?.[0].scrollTo({ top: document.getElementById(`title-delete-file`)?.offsetTop! - 32, behavior: 'smooth' })}>{t('docs.storage.menu.delete-file')}</div>
      </div>
      <div className='document md:px-8 flex-1 md:overflow-auto pb-16'>
        <div className='mt-16 md:mt-4 flex items-center justify-between flex-wrap'>
          <h1 id='title' className='title'>{t('docs.storage.menu.title')}</h1>
        </div>
        <div dangerouslySetInnerHTML={{ __html: t('docs.storage.section-1') }} />
        {/* upload */}
        <h2 className='title' id='title-upload-file'>{t('docs.storage.menu.upload-file')}</h2>
        <div dangerouslySetInnerHTML={{ __html: t('docs.storage.section-2') }} />
        <div className='mt-2'><CodeDisplay title={t('docs.storage.code-title.upload')} content={codeExamples.uploadFile} language={language} /></div>
        {/* download */}
        <h2 className='title' id='title-download-file'>{t('docs.storage.menu.download-file')}</h2>
        <div dangerouslySetInnerHTML={{ __html: t('docs.storage.section-3') }} />
        <div className='mt-2'><CodeDisplay title={t('docs.storage.code-title.get-file-content')} content={codeExamples.getFileContent} language={language} /></div>
        {/* delete */}
        <h2 className='title' id='title-delete-file'>{t('docs.storage.menu.delete-file')}</h2>
        <div dangerouslySetInnerHTML={{ __html: t('docs.storage.section-4') }} />
        <div className='mt-2'><CodeDisplay title={t('docs.storage.code-title.delete')} content={codeExamples.deleteFile} language={language} /></div>
      </div>
    </div>
  )
}

export default StorageAPI